const MIN_PHONE_DIGITS = 8;
const MAX_PHONE_DIGITS = 15;

export function looksLikePhone(value) {
  if (value == null) return false;
  const raw = String(value).trim();
  if (!raw || raw.includes('*')) return false;

  const digits = raw.replace(/\D/g, '');
  return digits.length >= MIN_PHONE_DIGITS && digits.length <= MAX_PHONE_DIGITS;
}

/**
 * Raw contact phone for an inbox conversation (Rails or MS).
 * Uses only `phone` / `contactPhone` — never `external_id` or `web_id`.
 *
 * @param {Object} conversation
 * @returns {string|undefined}
 */
export function resolveInboxConversationPhone(conversation = {}) {
  const explicit = conversation.contactPhone || conversation.phone;
  if (looksLikePhone(explicit)) return String(explicit).trim();

  return undefined;
}
